<template>
    <div class="ImportBomTypeFormComponent">


        <b-form-group :label="lang.label_1+':'" >
            <b-form-radio v-model="form.bomImportType" name="type-radios" value="csv">CSV
            </b-form-radio>
            <!-- <b-form-radio v-model="form.bomImportType" name="type-radios" value="lst">Variants.LST
            </b-form-radio> -->
        </b-form-group>
        
        

    </div>
</template>

<script>


export default {
    name: "ImportBomTypeFormComponent",
    components: {



    },
    props: {
        lang: Object
    },
    data() {
        return {
            form: {

                bomImportType: 'csv',

            },
            

        }
    },
    computed: {
        


    },
    created() {
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_importBomTypeForm", this.form)

    },
    updated() {

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_importBomTypeForm", this.form)

    },
    methods: {

    }
}
</script>
<style lang="scss">
.ImportBomTypeFormComponent {}
</style>



// WEBPACK FOOTER //
// src/components/shared/ImportBomTypeFormComponent.vue